export const engagementAudienceSyncPlatformAdAccountsAdAccountId =
  "/engagement/audience_sync/:platform/ad_accounts/:ad_account_id";
